export default __webpack_public_path__ + "static/media/subscriptionIcon.3434433b.svg";